
import { mapGetters } from 'vuex'
import { colors } from '~/helpers/colors'
export default {
  name: 'FilterListItem',
  props: {
    filterLabel: {
      type: String,
      required: true,
    },
    facetValues: {
      type: Array,
      default: () => [],
    },
    facetData: {
      type: Object,
      default: () => ({}),
    },
    wording: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      listItemToggled: false,
      filterActive: false,
    }
  },
  computed: {
    ...mapGetters({
      vxActivePriceFacets: 'search/getActivePriceFacets',
    }),
    activeFacetValues() {
      const activeFacets = this.facetValues.filter(({ active }) => active)
      switch (this.facetData.field) {
        // PRICES
        case 'ss_final_price':
          return this.parseActivePriceFacets()
        // COLOR SWATCHES
        case 'ss_normalize_color':
          return activeFacets.map(({ value }) => this.colorSwatch(value))
        default:
          return activeFacets.map(({ value }) => value)
      }
    },
  },
  methods: {
    colorSwatch(colorCode) {
      return colors[colorCode].EN
    },
    parseActivePriceFacets() {
      return this.vxActivePriceFacets.map((facet) => {
        const rangeSplit = facet.split('&')
        const rangeLow =
          rangeSplit[0].split('=')[1] !== '*' ? rangeSplit[0].split('=')[1] : 0
        const rangeHigh =
          rangeSplit[1].split('=')[1] !== '*'
            ? rangeSplit[1].split('=')[1]
            : '500'
        return `$${rangeLow} - $${rangeHigh}`
      })
    },
  },
}
